import { render } from "./UserItems.vue?vue&type=template&id=5f4a79e8&scoped=true"
import script from "./UserItems.vue?vue&type=script&lang=ts"
export * from "./UserItems.vue?vue&type=script&lang=ts"

import "./UserItems.vue?vue&type=style&index=0&id=5f4a79e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f4a79e8"

export default script